// SWAN Design System Fonts

export const fonts = {
  // Headlines - Aspekta
  headline: `'Aspekta', sans-serif`,

  // Body - Aspekta
  body: `'Aspekta', sans-serif`,
};

export default fonts;

